import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	InspectorControls,
	MediaUpload
} from '@wordpress/block-editor';

import {
	Button,
	PanelBody,
	__experimentalToggleGroupControl as ToggleGroupControl,
	__experimentalToggleGroupControlOption as ToggleGroupControlOption,
	RangeControl,
	TextControl,
	CheckboxControl,
	SelectControl, __experimentalNumberControl as NumberControl, RadioControl, FormTokenField, ToggleControl,
} from '@wordpress/components';

// editor style
import './editor.scss';

import SingleDoc from "./components/single-doc/SingleDoc";
import MultiDoc from "./components/multi-doc/MulltiDoc";
import { useSelect } from "@wordpress/data";
import { doc_ids } from "./components/multi-doc/custom-functions";
import { useEffect } from "@wordpress/element";

jQuery(document).ready(function () {
    jQuery(document).on('click', 'body:not(.ezd-premium) .eazydocs-pro-notice', function (e) {
		e.preventDefault();
		let href = jQuery(this).attr('href')
		Swal.fire({
			title: 'Opps...',
			html: 'This is a PRO feature. You need to <a href="admin.php?page=eazydocs-pricing"><strong class="upgrade-link">Upgrade&nbsp;&nbsp;➤</strong></a> to the Premium Version to use this feature',
			icon: "warning",
			buttons: [false, "Close"],
			dangerMode: true
		});
    });
});

export default function Edit( { attributes, setAttributes } ) {
	const {
		docTypes,
		docPreset,
		docSinglePreset,
		docId,
		sectionsNumber,
		sectionsTwoNumber,
		articlesNumber,
		parent_docs_order,
		readMoreText,
		sectionButton,
		isFeaturedImage,
		sectionButtonText,
		btnURL,
		titleText,
		titleTag,
		excerptCharNumber,
		topic_label,
		show_topic,
		col,
		include,
		exclude,
		show_docs,
		more,
		child_docs_order,
		orderBy,
		docs_layout,
		imageUrl
	 } = attributes

	const sortBy = orderBy === 'rand' ? 'title' : orderBy;

	// Get all posts which parent is 'docs' post type 5 post in sidebar
	const docPosts = useSelect((select) => {
		try {
			return select('core').getEntityRecords('postType', 'docs', {
				per_page: -1,
				order: 'desc',
				orderby: 'menu_order',
				parent: 0,
				status: ['publish', 'private'],
			});
		} catch (error) {
			console.error('Error fetching doc posts:', error);
			return [];
		}
	}, [child_docs_order]);

	const options = [
        { label: __('Select a Doc', 'eazydocs-pro'), value: '' }, // Empty option
        ...(docPosts ? docPosts.map(post => ({ label: post.title.rendered, value: post.id })) : [])
    ];

	const onImageSelect = (media) => {
		setAttributes({ imageUrl: media.url });
	};

	const multiDocs = useSelect((select) => {
		try {
			// Recreate multiDocsArgs every time orderBy or other dependencies change
			const multiDocsArgs = {
				per_page: show_docs,
				order: parent_docs_order, // or use orderBy here if needed
				orderby: sortBy,
				parent: 0,
				status: ['publish', 'private'],
			};

			// Include or exclude specific docs based on include and exclude attributes
			if (doc_ids(include).length > 0) {
				multiDocsArgs.include = doc_ids(include);
			}

			if (doc_ids(exclude).length > 0) {
				multiDocsArgs.exclude = doc_ids(exclude);
			}

			// Fetch the docs using the dynamically created multiDocsArgs
			return select('core').getEntityRecords('postType', 'docs', multiDocsArgs);
		} catch (error) {
			console.error('Error fetching doc posts:', error);
			return [];
		}
	}, [show_docs, orderBy, include, exclude, parent_docs_order]);

	const docs = useSelect( (select) => {
		return select("core").getEntityRecords('postType', 'docs', {
			parent: 0,
			status: ['publish', 'private']
		})
	}, [])

	useEffect(() => {
		if(docId === null) {
			if (docPosts !== undefined || docPosts.length !== 0) {
				if(docPosts){
					setAttributes({ docId : docPosts[0].docId });
				}
			}
		}
	}, [docPosts]);

	const docSuggestions = docs ? docs.map((doc) => doc.id + " | " + doc.title.rendered) : [];
	// console.log("docSuggestions", docSuggestions);

	const orderOptions = [
		{ label: __('Ascending', 'eazydocs-pro'), value: 'asc' },
		{ label: __('Descending', 'eazydocs-pro'), value: 'desc' },
	];

	const layoutOptions = [
		{ label: __('Masonry', 'eazydocs-pro'), value: 'masonry' },
		{ label: __('Grid', 'eazydocs-pro'), value: 'grid' },
	];

	const parentOrderOptions = [		
		{ label: __('Title', 'eazydocs-pro'), value: 'title' },
		{ label: __('Post Author', 'eazydocs-pro'), value: 'author' },
		{ label: __('Date', 'eazydocs-pro'), value: 'date' },
		{ label: __('Post ID', 'eazydocs-pro'), value: 'id' },
		{ label: __('Last Modified Date', 'eazydocs-pro'), value: 'modified' },
		{ label: __('Random', 'eazydocs-pro'), value: 'rand' },
		{ label: __('Menu Order', 'eazydocs-pro'), value: 'menu_order' },
	];
	
	const proAlert 		= eazydocs_local_object.is_ezd_pro_block == 'yes' ? '' : ' Pro';
	const proAlertClass = eazydocs_local_object.is_ezd_pro_block == 'yes' ? '' : 'eazydocs-pro-notice';

	function handleDocOption(val){
		setAttributes({docTypes: val});
	}
	
	return (
		<>
			<InspectorControls>
				<PanelBody
					initialOpen={true}
					title={__("Select Doc's Type test", 'eazydocs-pro')}
					>
					<ToggleGroupControl
						label={__("Doc Type", 'eazydocs-pro')}
						value={docTypes}
						isBlock
						__nextHasNoMarginBottom
						onChange={handleDocOption}
						>
						<ToggleGroupControlOption value="single-doc" label={__("Single Doc", 'eazydocs-pro')} />
						<ToggleGroupControlOption value="multi-doc" label={__("Multi Doc", 'eazydocs-pro')} />
					</ToggleGroupControl>
								
					{/* Title  */}
					{docPreset === 'creative' && (
						<PanelBody
							initialOpen={false}
							title={__('Title Settings', 'eazydocs-pro')}
							>
							<TextControl
								label={__('Title Text', 'eazydocs-pro')}
								value={titleText}
								onChange={(value) => setAttributes({ titleText: value })}
							/>
							<SelectControl
								label={__('Title Tag', 'eazydocs-pro')}
								value={titleTag}
								options={[
									{ label: 'H1', value: 'h1' },
									{ label: 'H2', value: 'h2' },
									{ label: 'H3', value: 'h3' },
									{ label: 'H4', value: 'h4' },
									{ label: 'H5', value: 'h5' },
									{ label: 'H6', value: 'h6' },
								]}
								onChange={(value) => setAttributes({ titleTag: value })}
								__nextHasNoMarginBottom
							/>
							<MediaUpload
								onSelect={(media) => setAttributes({ imageUrl: media.url })}
								allowedTypes={['image']}
								value={imageUrl ?? ezdAssets.ezd_img_dir + '/widgets/docbg-shap.png'}
								render={({ open }) => (
									<>
										<div style={{ marginBottom: '10px' }}>
										{__('BACKGROUND IMAGE', 'eazydocs-pro')}
										 
											<div style={{ marginTop: '10px' }}>
												<img
													src={imageUrl ?? ezdAssets.ezd_img_dir + '/widgets/docbg-shap.png'}
													alt={__('Preview Image', 'eazydocs-pro')}
													style={{ maxWidth: '100px', height: '50px' }}
												/>
											</div>
									 
											<Button style={{ marginTop: '10px' }} className="button widefat" onClick={open} variant="secondary">
												{imageUrl ?? ezdAssets.ezd_img_dir + '/widgets/docbg-shap.png'
													? __('Replace Image', 'eazydocs-pro')
													: __('Upload Image', 'eazydocs-pro')}
											</Button>
										</div>
									</>
								)}
							/>
						</PanelBody>
					)}
					
					<PanelBody
						initialOpen={true}
						title={__('Settings', 'eazydocs-pro')}
						>
						{docTypes === 'single-doc' && (						
							<>
								<SelectControl
									label={__('Select a Doc', 'eazydocs-pro')}
									value={docId}
									options={options}
									onChange={(newId) => setAttributes({ docId: newId })}
									__nextHasNoMarginBottom
								/>
							</>
						)}

						{docPreset != 'collaborative_docs' && (
							<>
								{!(docTypes === 'single-doc' && ['docbox'].includes(docSinglePreset)) &&
								!(docTypes === 'multi-doc' && ['flat_tabbed_docs'].includes(docPreset)) && (
									<RangeControl
									initialPosition={ col }
									label={__('Columns', 'eazydocs-pro')}
									max={6}
									min={1}
									shiftStep={2}
									onChange={(val) => {
										setAttributes({ col: val });
									}}
									/>
								) }
							
								{!(docTypes === 'single-doc' && ['topicsbox', 'docbox'].includes(docSinglePreset)) &&
								!(docTypes === 'multi-doc' && ['flat_tabbed_docs'].includes(docPreset)) && (
									<RadioControl
										label={__('Docs Layout' + `${proAlert}`, 'eazydocs-pro')}
										selected={docs_layout}
										options={layoutOptions}
										className={`${proAlertClass}`}
										disabled={eazydocs_local_object.is_ezd_pro_block == 'yes' ? false : true}
										onChange={(value) => setAttributes({ docs_layout: value })}
									/>
								) }
							</>
						)}

						{/* Sections */}
						{ docPreset != 'collaborative_docs' && (
							<>
								{(docTypes === 'single-doc' && [ 'topicsbox', 'docbox','box', 'creative', 'light'].includes(docSinglePreset)) ||
								(docTypes === 'multi-doc' && ['docbox', 'boxed_tabbed_docs', 'tabbed_doc_list'].includes(docPreset)) ? (
									<NumberControl
										label={__('Sections', 'eazydocs-pro')}
										help={__( 'Number of Sections to display. Use -1 to show all.', 'eazydocs-pro' )}
										isShiftStepEnabled={true}
										onChange={(newValue) => setAttributes({ sectionsNumber: newValue })}
										shiftStep={10}
										value={sectionsNumber}
									/>
								) : null}
								
								{docSinglePreset === 'topicsbox' && docTypes === 'single-doc' && (
									<>
										<NumberControl
											label={__('Sections 2', 'eazydocs-pro')}
											isShiftStepEnabled={true}
											onChange={(newValue) => setAttributes({ sectionsTwoNumber: newValue })}
											shiftStep={10}
											value={sectionsTwoNumber}
										/>
										<NumberControl
											label={__('Excerpt Chars', 'eazydocs-pro')}
											isShiftStepEnabled={true}
											onChange={(newValue) => setAttributes({ excerptCharNumber: newValue })}
											shiftStep={10}
											value={excerptCharNumber}
										/>
									</>
								)}

								{ docSinglePreset != 'topicsbox' && (
									<NumberControl
										label={__('Articles', 'eazydocs-pro')}
										help={__( 'Number of articles to display. Use -1 to show all.', 'eazydocs-pro' )}
										isShiftStepEnabled={true}
										onChange={(newValue) => setAttributes({ articlesNumber: newValue })}
										shiftStep={10}
										value={ articlesNumber }
									/>
								)}
							</>
						)}

						{/* Topics Count */}
						{docPreset !== 'docbox' && docPreset !== 'collaborative_docs' && (
							<>
								{((docTypes === 'single-doc' && ['box', 'light'].includes(docSinglePreset)) ||
								(docTypes === 'multi-doc' && ['box', 'light'].includes(docPreset))) ? (
									<>
										<CheckboxControl
											label={__('Topic Count', 'eazydocs-pro')}
											checked={show_topic}
											onChange={(value) => setAttributes({ show_topic: value })}
										/>

										{show_topic && docPreset !== 'box' && (
											<TextControl
												label={__('Topic Count Text', 'eazydocs-pro')}
												value={topic_label}
												onChange={(value) => setAttributes({ topic_label: value })}
											/>
										)}
									</>
								) : null}
							</>
						)}

					{/* Number of Docs */}
					{ docTypes === 'multi-doc' && (
						<>
							<NumberControl
								label={__('Number of Docs', 'eazydocs-pro')}
								isShiftStepEnabled={ true }
								onChange={(value) => setAttributes({ show_docs: value }) }
								shiftStep={10}
								value={ show_docs }
								min={1}
								__nextHasNoMarginBottom
								help={__('Number of Main Docs to show', 'eazydocs-pro')}
							/>

							{/* Include/Exclude Docs */}
							{ exclude.length === 0 && (
							<FormTokenField
								__experimentalAutoSelectFirstMatch
								__experimentalExpandOnFocus
								label={__( 'Docs to Show', 'eazydocs-pro' )}
								help={__( 'Select specific docs to show. Leave empty to show all.', 'eazydocs-pro' )}
								suggestions={ docSuggestions}
								value={include}
								onChange={(value) => setAttributes({ include: value })}
							/>
							)}

							{ include.length === 0 && (
							<FormTokenField
								__experimentalAutoSelectFirstMatch
								__experimentalExpandOnFocus
								label={__('Docs Not to Show', 'eazydocs-pro')}
								help={__( 'Select specific docs to exclude.', 'eazydocs-pro' )}
								suggestions={ docSuggestions}
								value={exclude}
								onChange={(value) => setAttributes({ exclude: value })}
							/>
							)}
						</>
					)}
					
					{ docSinglePreset != 'topicsbox' && docPreset != 'docbox' && docPreset != 'collaborative_docs' && (
						<>
							{docPreset != 'creative' &&  (
								<TextControl
									label={__('Read More Button', 'eazydocs-pro')}
									value={readMoreText}
									onChange={(value) => setAttributes({ readMoreText: value })}
								/>
							)}
							
							{(docTypes === 'single-doc' && ['creative', 'light'].includes(docSinglePreset)) ||
							(docTypes === 'multi-doc' && ['creative', 'light'].includes(docPreset)) ? (
								<>
									<ToggleControl
										label={__('Section Button enable', 'eazydocs-pro')}
										checked={sectionButton}
										onChange={(newValue) => setAttributes({ sectionButton: newValue })}
									/>
									
									{sectionButton && docPreset !== 'box' && (
										<div>
											<TextControl
												label={__('Button text', 'eazydocs-pro')}
												value={sectionButtonText}
												onChange={(value) => setAttributes({ sectionButtonText: value })}
											/>
											<TextControl
												label={__('Button URL', 'eazydocs-pro')}
												value={btnURL}
												onChange={(value) => setAttributes({ btnURL: value })}
											/>
										</div>
									)}
								</>
							) : null}
						</>
					)}

						{!(docTypes === 'single-doc' && ['docbox'].includes(docSinglePreset)) &&
						!(docTypes === 'multi-doc' && ['boxed_tabbed_docs', 'tabbed_doc_list', 'docbox'].includes(docPreset)) && (
							<ToggleControl
								label={__('Featured Image', 'eazydocs-pro')}
								checked={isFeaturedImage}
								onChange={(newValue) => setAttributes({ isFeaturedImage: newValue })}
							/>
						)}
						
					</PanelBody>
					
					<PanelBody
						initialOpen={false}
						title={__("Order", 'eazydocs-pro')}
					>
						<SelectControl
							label={__('Order by' + `${proAlert}`, 'eazydocs-pro')}
							value={orderBy}
							options={parentOrderOptions}
							disabled={eazydocs_local_object.is_ezd_pro_block == 'yes' ? false : true}
							className={`${proAlertClass}`}
							onChange={(value) => setAttributes({ orderBy: value })}
							help={__('Some of the options ( Random ) might not show in the editor but will worked in frontend', 'eazydocs-pro')}
						/>
						
						<SelectControl
							label={__('Parent Docs Order', 'eazydocs-pro')}
							value={parent_docs_order}
							options={orderOptions}
							onChange={(newVal) => setAttributes({ parent_docs_order: newVal })}
							__nextHasNoMarginBottom
						/>
						
						<SelectControl
							label={__('Child Docs Order', 'eazydocs-pro')}
							value={child_docs_order}
							options={orderOptions}
							onChange={(value) => setAttributes({ child_docs_order: value })}
						/>
					</PanelBody>

				</PanelBody>

				{docTypes === 'multi-doc' && (
					<TextControl
						value={docPreset}
						style={{ display: 'none' }}
					/>
				)}

				{docTypes === 'single-doc' && (
					<TextControl
						value={docSinglePreset}
						onChange={(value) => setAttributes({ docSinglePreset: value })}
						style={{ display: 'none' }}
					/>
				)}

			</InspectorControls>
			
			<div {...useBlockProps()}>
				{ docTypes === "single-doc" && <SingleDoc attributes={attributes} setAttributes={setAttributes} articlesNumber={articlesNumber} /> }
				{ docTypes === "multi-doc" && <MultiDoc attributes={attributes} setAttributes={setAttributes} docPosts={docPosts} multiDocs={multiDocs} /> }
			</div>
		</>
	)
}